var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");

var CfpData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);
};
lib_core.inherit(CfpData, DualRowPackageData);
lib_core.JsonParser.registerClass(CfpData, "CfpData");

module.exports = CfpData;
